import { ClientPropertyCategoryEnum } from "web_myplann/Infrastructure/Api/Api";

export const LAND_CATEGORY_OPTIONS = {
	Livving: ClientPropertyCategoryEnum.Livving,
	CommercialBuilding: ClientPropertyCategoryEnum.CommercialBuilding,
	Garden: ClientPropertyCategoryEnum.Garden,
	PermanentGrassGrowth: ClientPropertyCategoryEnum.PermanentGrassGrowth,
	Forest: ClientPropertyCategoryEnum.Forest,
	AgriculturalLand: ClientPropertyCategoryEnum.AgriculturalLand,
	OtherLand_: ClientPropertyCategoryEnum.OtherLand_,
} as const;
